import type { ReservationStatus } from "@/types/reservation";
import { STATUS_COLORS, STATUS_LABELS } from "@/lib/status";

export function StatusBadge({ status }: { status: ReservationStatus }) {
  const color = STATUS_COLORS[status];
  return (
    <span
      className="status-badge"
      style={{ background: color.bg, color: color.fg, borderColor: color.border }}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
